@for (operation of operations(); track operation.id) {
  <div class="group relative">
    <button
      type="button"
      class="flex items-center gap-2 rounded-[10px] px-2.5 py-0.5 bg-transparent font-['Manrope'] text-base text-[var(--mat-app-on-surface)] border border-[var(--mat-app-on-surface)] cursor-pointer hover:bg-[var(--mat-app-hover-background)]"
      [attr.aria-label]="'BACKGROUND_OPERATIONS.COI_GENERATION.TITLE' | translate">
      <span class="whitespace-nowrap">{{ 'BACKGROUND_OPERATIONS.COI_GENERATION.TITLE' | translate }}</span>

      @switch (operation.status) {
        @case (statuses.InProgress) {
          <span class="h-3 w-3 rounded-full bg-[var(--mat-app-primary)]" aria-hidden="true"></span>
          <span class="whitespace-nowrap text-sm">{{ 'BACKGROUND_OPERATIONS.STATUS.IN_PROGRESS' | translate }}</span>
        }
        @case (statuses.Completed) {
          <span class="h-3 w-3 rounded-full bg-[var(--mat-app-success)]" aria-hidden="true"></span>
          <span class="whitespace-nowrap text-sm">{{ 'BACKGROUND_OPERATIONS.STATUS.COMPLETED' | translate }}</span>
        }
        @case (statuses.Failed) {
          <span class="h-3 w-3 rounded-full bg-[var(--mat-app-error)]" aria-hidden="true"></span>
          <span class="whitespace-nowrap text-sm">{{ 'BACKGROUND_OPERATIONS.STATUS.FAILED' | translate }}</span>
        }
      }

      <mat-icon class="!flex !h-5 !w-5 shrink-0 items-center justify-center !text-xl !leading-5" aria-hidden="true">help_outline</mat-icon>
    </button>

    <div class="invisible absolute right-0 top-full z-50 translate-y-1 pt-2 opacity-0 transition-[opacity,transform,visibility] duration-300 ease-out group-focus-within:visible group-focus-within:translate-y-0 group-focus-within:opacity-100 group-hover:visible group-hover:translate-y-0 group-hover:opacity-100">
      <div
        class="flex w-[38rem] max-w-[90vw] items-center justify-between gap-4 rounded-[10px] border border-[var(--mat-app-outline-variant)] bg-[var(--mat-app-surface-container)] py-1 pl-4 pr-2 text-sm text-[var(--mat-app-on-surface-variant)]"
        role="status">
        <span>
          @switch (operation.status) {
            @case (statuses.InProgress) {
              {{ 'BACKGROUND_OPERATIONS.COI_GENERATION.IN_PROGRESS' | translate: { policyNumber: operation.policyNumber ?? '' } }}
            }
            @case (statuses.Completed) {
              {{ 'BACKGROUND_OPERATIONS.COI_GENERATION.COMPLETED' | translate: { policyNumber: operation.policyNumber ?? '' } }}
            }
            @case (statuses.Failed) {
              {{ 'BACKGROUND_OPERATIONS.COI_GENERATION.FAILED' | translate: { policyNumber: operation.policyNumber ?? '' } }}
            }
          }
        </span>

        <button mat-button type="button" class="shrink-0 !h-8" (click)="onOpen(operation)">
          {{ 'BACKGROUND_OPERATIONS.OPEN' | translate }}
        </button>
      </div>
    </div>
  </div>
}
